import { get } from 'lodash';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { ButtonItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';
import type { HeroItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/heroItemAttributes';
import type { HeroSliderItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/heroSliderItemAttributes';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

import ButtonsSetting from './ButtonsSetting';
import HeadlinesSetting from './HeadlinesSetting';
import HeroSliderGlobalSetting from './HeroSliderGlobalSetting';
import SublinesSetting from './SublinesSetting';

const HEADERS_ID_PATH = Object.freeze(['children', [0], 'id']);
const SUBLINES_ID_PATH = Object.freeze(['children', [1], 'id']);
const BUTTONS_ID_PATH = Object.freeze(['children', [2], 'id']);

export type HeroSliderItem = DocumentItem<HeroSliderItemAttributes> & {
  children: [
    DocumentItem<HeroItemAttributes>,
    DocumentItem<HeroItemAttributes>,
    DocumentItem<ButtonItemAttributes>,
  ];
};

export type HeroSliderGlobalSettingProps = Pick<
  ComponentSettingsTab,
  'onChange' | 'permissions'
> & {
  item: DocumentItem<SectionItemAttributes> & {
    children: [HeroSliderItem];
  };
};

const Style = ({
  onChange,
  item,
  permissions,
}: HeroSliderGlobalSettingProps) => {
  const slides = item.children;

  const [headline, subline, button] = slides[0].children;

  const idsFrom = (path) => slides.map((slide) => get(slide, path));

  return (
    <ContentWrapper>
      <AccordionTitle title={__('Global Settings')}>
        <HeroSliderGlobalSetting
          item={item}
          onChange={onChange}
          permissions={permissions}
        />
      </AccordionTitle>
      <HeadlinesSetting
        headerIds={idsFrom(HEADERS_ID_PATH)}
        item={headline}
        onChange={onChange}
        permissions={permissions || { can: {} }}
      />
      <SublinesSetting
        sublineIds={idsFrom(SUBLINES_ID_PATH)}
        item={subline}
        onChange={onChange}
        permissions={permissions || { can: {} }}
      />
      <ButtonsSetting
        buttonsIds={idsFrom(BUTTONS_ID_PATH)}
        item={button}
        onChange={onChange}
        defaultAttributes={{} as ButtonItemAttributes}
      />
    </ContentWrapper>
  );
};

export default Style;

const ContentWrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  width: '100%',
}))``;
